export const ENTITY_PICKER_GET_ENTITY_LIST = "ENTITY_PICKER_GET_ENTITY_LIST";
export const ENTITY_PICKER_GET_ENTITY_LIST_RESPONSE = "ENTITY_PICKER_GET_ENTITY_LIST_RESPONSE";